// extracted by mini-css-extract-plugin
export default {"screens_page_layout":"styles_screens_page_layout__AQvhq"};